import Tooltips from "./tooltip";

const IconHover = ({ children, onClick, additionalclasses, position, content, command }) => {
    const button = (
        <div onClick={onClick} className={`${additionalclasses} hover:custom-bg-white-50 rounded-[4px] transtion-all duration-300 w-fit cursor-pointer px-[5px] py-[5px]`} >
            {children}
        </div>
    );

    // Only wrap in a tooltip when there's something to show — callers like
    // SidebarToggle put their tooltip on the child instead. Keep the same
    // `relative` wrapper Tooltips renders so absolutely-positioned callers
    // (nav-menu-item) lay out exactly as before.
    if (!content) return <div className="relative ">{button}</div>;

    return (
        <Tooltips position={position} content={content} command={command}>
            {button}
        </Tooltips>
    );
};

export default IconHover;
